import { useMemo, useSyncExternalStore } from 'react';
import { statsigStore } from '../bootstrap/statsigStore';
import {
	deriveIsRovoContextMenuEnabled,
	deriveIsRovoContextMenuHighlightFabEnabled,
	deriveIsRovoContextMenuRightClickFabEnabled,
	deriveIsRovoContextMenuSearchFullPageEnabled,
	deriveIsRovoContextMenuSearchInSidePanelEnabled,
	getAllRovoContextMenuVariants,
	type RovoContextMenuHighlightEntryVariant,
	type RovoContextMenuSearchBehaviorVariant,
} from '../experiment/experiments';

export type ProactiveContextMenuVariants = {
	highlightEntry: RovoContextMenuHighlightEntryVariant;
	searchBehavior: RovoContextMenuSearchBehaviorVariant;
	isRovoContextMenuEnabled: boolean;
	isHighlightFabEnabled: boolean;
	isRightClickFabEnabled: boolean;
	isSearchInSidePanelEnabled: boolean;
	isSearchFullPageEnabled: boolean;
};

export const useProactiveContextMenuVariants = (): ProactiveContextMenuVariants => {
	const statsigVersion = useSyncExternalStore(
		statsigStore.subscribe,
		statsigStore.getSnapshot,
		statsigStore.getSnapshot,
	);

	return useMemo<ProactiveContextMenuVariants>(() => {
		const { highlightEntry, searchBehavior } = getAllRovoContextMenuVariants();
		return {
			highlightEntry,
			searchBehavior,
			isRovoContextMenuEnabled: deriveIsRovoContextMenuEnabled(highlightEntry, searchBehavior),
			isHighlightFabEnabled: deriveIsRovoContextMenuHighlightFabEnabled(highlightEntry),
			isRightClickFabEnabled: deriveIsRovoContextMenuRightClickFabEnabled(highlightEntry),
			isSearchInSidePanelEnabled: deriveIsRovoContextMenuSearchInSidePanelEnabled(searchBehavior),
			isSearchFullPageEnabled: deriveIsRovoContextMenuSearchFullPageEnabled(searchBehavior),
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [statsigVersion]);
};
